<mat-card appearance="outlined" class="notification-card">
  <mat-card-content [class]="contentClass()">
    <div class="d-flex align-items-center gap-2">
      <mat-icon class="mat-text-primary flex-shrink-0">{{ iconName() }}</mat-icon>
      <span class="mat-font-label-md fw-semibold flex-fill">{{ title() }}</span>
      <ng-content select="[notifBadge]"></ng-content>
    </div>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
